/**
 * Domain types for the wit-payment-service integration.
 *
 * These are the CLEAN shapes the rest of the system consumes. The upstream
 * `{ status, data }` wire envelopes are mapped onto these in
 * `http-payment.ts` (and the wire Zod schemas are isolated to that file), so a
 * future API change touches only one file.
 *
 * IMPORTANT: all money amounts are in **cents** (integers). No formatting,
 * rounding, or currency conversion happens in this package — format only at the
 * UI edge.
 */
/**
 * Operator-facing RU label per match signal. `Record<CustomerMatchSignal, …>`
 * on purpose: adding a signal to the union without a label fails the build,
 * which is the only mechanism that keeps «основание совпадения» from degrading
 * into a raw machine key in front of an operator.
 */
export const CUSTOMER_MATCH_SIGNAL_RU = {
    card_last4: 'цифры карты',
    wallet_last4: 'цифры токена кошелька (Apple/Google Pay)',
    email: 'адрес аккаунта',
    billing_email: 'адрес из платежа',
    name: 'имя',
};
//# sourceMappingURL=types.js.map